export default __webpack_public_path__ + "static/media/Image 97.e3815445.png";